// constants.js
export const Content = [
  "Company Name to be quoted",
  "Opportunity ID",
  "Opportunity Type",
  "Location of Buyer",
  "Partner/Resellers",
  "Broker/Consultant",
  "Broker Commission?",
  "Broker Commission (%)",
  "Total HC to be quoted",
  "Currency requested",
];

export const CheckboxLabels = [
  "Scheduled in-person sessions",
  "Scheduled video sessions",
  "Scheduled phone sessions",
  "Single Session Therapy",
  "Daily Living",
  "Child Care",
  "Elder Care",
  "Life Coaching",
  "Legal Research and Referral",
  "Computerized CBT (English only)",
  "Counseling Match To Insurance",
  "Aware (Mindfulness Program)",
  "Financial Research and Referral",
  "Member Website",
  "Manager Assist",
];

export const Constant = {
  BREADCRUMB_NAME_CREATE: "Create Request",
  BREADCRUMB_NAME_EDIT: "Edit Request",
  BREADCRUMB_NAME_DUPLICATE: "Duplicate Request",
  FORM_HEADING: "Please continue by filling out the form now.",
  FORM_HEADING1:
    "To continue, kindly upload the list of countries for which you're generating this quote.",
  FORM_HEADING2:
    "File is uploaded, but their are some validation errors. Please correct them below.",
  FORM_HEADING3: "Great! Please continue by filling out the form now.",
  SAMPLE: "Excel template",
  WRONGFILETYPE:
    "Please upload correct file. Use excel template for reference.",
  EMPTYFILEERROR: "No data found!. Please check the uploaded file.",
  INVALIDHEADCOUNTERROR:
    "Invalid headcount value found! Please check the uploaded file.",
  MISSINGFIELDERROR:
    "Country and Headcount fields are missing!. Please check the uploaded file. Use excel template for reference.",
  FILEUPLOADERROR: "File Upload Failed. Please use another file.",
  LONGNAMEERROR:
    "The file name is too large [Max: 250 characters], please rename and re-upload",
  CRM_DATA: "CRM Data",
  ACCORDIAN_SUBTITLE: "Prefetched Data*",
  QUOTE_DETAILS: "Quote Details",
  ACCORDIAN_SUBTITLETWO: "All the fields are mandatory*",
  CRM_LABEL1: "Company Name to be quoted",
  CRM_LABEL2: "Opportunity ID",
  CRM_LABEL3: "Pricing Type",
  CRM_LABEL4: "Location of Buyer",
  CRM_LABEL5: "Partner/Resellers",
  CRM_LABEL6: "Broker/Consultant",
  CRM_LABEL7: "Broker Commission?",
  CRM_LABEL8: "Broker Commission (%)",
  CRM_LABEL9: "Total HC to be quoted",
  CRM_LABEL10: "Currency requested",
  CRM_LABEL11: "Account-Sub Type",
  CRM_LABEL12: "Date we started serving Company",
  CRM_LABEL13: "UCMS Id",
  SECOND_ACCORDIAN_LABEL1:
    "Current number of lives served through the Partner/Reseller",
  TOOLTIP_TITLE:
    "Please download the excel template for uploading country data.",
  TOOLTIP_TITLE1:
    "If opportunity is through a reseller. # of lives in domestic market vs. outside domestic market",
  TOOLTIP_TITLE2:
    "Even if they don't ask; check the total headcount of the company (research online or simply ask them). Potential volume impacts pricing consideration",
  TOOLTIP_TITLE3:
    "Attach the pricing grid to be completed and other useful RFP documents provided (i.e.: service requirements or SLAs). for complex requests, set up a call with JB to review.",
  TOOLTIP_TITLE4:
    "Specify if quote was provided to prospect in the past and when. Including why we lost. Check CRM 100% of the time. If no quote provided in the past, please type N/A",
  TOOLTIP_TITLE5:
    "For prospect who has an existing program with another vendor, indicate current utilization. Ask this question to prospect, partner or broker involved. If no information is available, please type N/A",
  TOOLTIP_TITLE7:
    "If you know the location(s) or have suggestions for where the RAM should be, please list them",
  TOOLTIP_TITLE8: "standard TAT to be determined",
  TOOLTIP_TITLE9: "for eLearning only",
  TOOLTIP_TITLE10:
    "Please insert any additional information that can help support your pricing request",
  TOOLTIP_TITLE11: "#cases and utilization % per year",
  SECOND_ACCORDIAN_LABEL2:
    "Total potential headcount outside what is requested to be quoted",
  SECOND_ACCORDIAN_LABEL3: "For formal RFP",
  IF_APPLICABLE: "(If applicable)",
  SECOND_ACCORDIAN_LABEL4: "Formal RFP Notes",
  SECOND_ACCORDIAN_LABEL5: "Name(s) of Competitors Bidding",
  SECOND_ACCORDIAN_LABEL6: "Past quotes",
  SECOND_ACCORDIAN_LABEL7: "Current Utilization with another vendor",
  SECOND_ACCORDIAN_LABEL8: "Deadline",
  SECOND_ACCORDIAN_LABEL9: "Number of RAM(s)",
  SECOND_ACCORDIAN_LABEL10: "Location of RAM(s)",
  SECOND_ACCORDIAN_LABEL11: "SAM Pricing Recommendation and assumptions",
  SECOND_ACCORDIAN_LABEL12: "Product name",
  SECOND_ACCORDIAN_LABEL13: "Product variation",
  SECOND_ACCORDIAN_LABEL14: "Number of years",
  SECOND_ACCORDIAN_RENEWAL_LABEL1:
    "If Client is already being served through another Partner - current rate, headcount, session model and utilization",
  SECOND_ACCORDIAN_RENEWAL_LABEL2: "Current rate and when it became effective",
  SECOND_ACCORDIAN_RENEWAL_LABEL3:
    "Rate and headcount covered for past 3 years ",
  SECOND_ACCORDIAN_RENEWAL_LABEL4: "Annual utilization (up to past 3 years)",
  SECOND_ACCORDIAN_RENEWAL_LABEL5: "Estimated number of AM Hours per year",
  SECOND_ACCORDIAN_RENEWAL_LABEL6: "Add Your Comment",
  COMPONENTS: "Components",
  SESSION: "Session",
  UTILIZATION: "Utilization (%)",
  AMHOURS: "AM Hours",
  SEATCOUNT: "Seat Count",
  PRICING_STRUCTURE: "Pricing Structure",
  ADDITIONALNOTES: "Additional Notes",
  DISCOUNT: "Discount/Rate increase",
  BUNDLEDISCOUNT: "Bundle Discount/Rate increase",
  HOURS: "Hours",
  ENTERHOURS: "Enter Hours",
  CALCULATE: "Calculate",
  UTILIZATION_DISTRIBUTION: "Utilization Distribution",
  EDIT: "Edit",
  PRICING_CALCULATION: "Pricing Calculation ",
  ALL_IN_PRICE: "(All in price)",
  TCVCAD: "TCV (CAD)",
  PEPM: "PEPM",
  AUD1: "AUD 3.69",
  PEPM_USD: "PEPM-USD",
  AUD2: "AUD 3.69",
  GO_BACK: "Go Back",
  SAVE_DRAFT: "Save as Draft",
  SUBMIT_VIEW: "Submit Quote & View",
  APPROVE: "Approve",
  REJECT: "Reject",
  SAVE: "Save",
  TOTAL_RESULT: "Total Results",
  BANNER_HEADING: "Create New Quote Request",
  BANNER_PARAGRAPH:
    "Ready to get a personalized quote? Fill out the form to create a new quote request effortlessly. Let's start now",
  BANNER_HEADING_EDIT: "Edit Quote Request",
  BANNER_PARAGRAPH_EDIT: "Need to make changes to your quote? Let's start now",
  BANNER_HEADING_DUPLICATE: "Duplicate Quote Request",
  BANNER_PARAGRAPH_DUPLICATE: "Need a duplicate quote? Let's start now",
  CANCEL: "Cancel",
  CORRECT_NUMBER_ERROR: "The value must be a number.",
  NUMBER_REQUIRED: "This field is required.",
  SESSION_REQUIRED: "This field is required.",
  VALID_SESSION: "Please Enter a valid session value",
  SESSION_LIMIT: "Number should be less than 25 and greater than 0",
  VALID_NOOFYEARS: "Please Enter a valid number of years value",
  NOOFYEARS_LIMIT: "Number should be less than 10 and greater than 0",
  UTLIZATION_NUMBER_REQUIRED: "This field is required.",
  UTLIZATION_NUMBER_VALID: "Please Enter a valid number",
  UTLIZATION_NUMBER_GREATER: "This field cannot be negative or zero.",
  HOURS_REQUIRED: "This field is required.",
  VALID_HOURS: "Please enter a valid hours value",
  SELECT_OPTION: "This field is required.",
  OTHERPRODUCT: "Other Products",
  ADDCOUNTRY: " Add Country Head Count",
  NODATA: "No Data Calculated",
  FILENAMEMAXLENGTH: 250,
  CORRECT_POSITIVE_NUMBER_ERROR: "The value must be a positive whole number.",
  FILEMAXSIZEINBYTE: 31457280,
  FILESIZEEXCEEDERROR:
    "The file size is too large [Max: 30 MB], please re-upload",
  SINGLECOUNTRYSUCCESS: "New Country is added successfully",
  COUNTRYERROR: "Please keep atleast one country",
  COUNTRYUPDATESUCCESS: "Country-Headcount updated successfully",
  MAXSAFEINTEGER: 2147483647,
  LIMITERROR: "The headcount value entered exceeds the allowed limit",
  CONFIRM: "Confirm",
  FLOORMARGINPOPUP:
    "Revenue stage 4 is less than Floor margin. Do you want to go ahead with submitting a quote under floor margin?",
  QUOTEDETAILEAP: "*Sum of EAP & clinical GA *Sum of WL core & WL GA",
};
export const ProductList = {
  EAP: "EAP",
  EVOLUTION: "Evolution",
  TOTALSOURCE: "Total Source",
  STUDENTASSIST: "Student Assist",
  WELLNESSCOACH: "Wellness Coaching",
  WORKLIFE: "Work Life",
  ENHANCEDFINANCIALSETTING: "Enhanced Financial Services",
  ENHANCEDLEGALSERVICE: "Enhanced Legal Services",
  HELPLINE: "Helpline",
  BANK: "Bank of Hours/Additional Counseling Sessions",
  PATHWAYS: "Pathways",
  GWQ: "Global Wellbeing Questionnaire",
  NPRW: "New Parent Return to Work",
};

export const AllProductsEnum = {
  EAP: 1,
  TOTALSOURCE: 2,
  EVOLUTION: 3,
  WORKLIFE: 4,
  WELLNESSCOACHING: 5,
  GLOBALWELLBEINGQUESTIONNAIRE: 6,
  NEWPARENTRETURNTOWORK: 7,
  BANKOFHOURSADDITIONALCOUNSELINGSESSIONS: 8,
  PATHWAYS: 9,
  ENHANCEDLEGALSERVICES: 10,
  ENHANCEDFINANCIALSERVICES: 11,
  HELPLINE: 12,
  STUDENTASSIST: 13,
  ACCOUNTMANAGEMENTHOURS: 14,
  AIR2_0: 15,
  AIRPROGRAMFORMANAGERS: 16,
  AMPLIFYLIGHT: 17,
  AMPLIFYSTANDARD: 18,
  ANSWER24EMERGENTCALLS: 19,
  ANSWER24LEVEL1: 20,
  ANSWER24LEVEL2: 21,
  ANSWER24LEVEL3: 22,
  ANSWER24MESSAGEONLYENHANCED: 23,
  AUTISMCARECOACHBASIC: 24,
  AUTISMCARECOACHENHANCED: 25,
  AWARE: 26,
  BEWELLATWORK: 27,
  BIOMETRICSCREENING: 28,
  CARECOACH: 29,
  COMPLIANCELINE: 30,
  CONSULTING: 31,
  CONTENTAPIGENERATOR: 32,
  CUSTOMPROMOTIONALMATERIAL: 33,
  DEDICATEDPHONELINE: 34,
  DUTY2CARE: 35,
  ELEARNINGPLATFORM: 36,
  ELEVATE: 37,
  EMOTIONALSUPPORTISOS: 38,
  EXPATRIATESERVICES: 40,
  FINANCIALASSIST: 41,
  FLUSHOT: 42,
  FOCUSBILEVEL2: 43,
  FOCUSBILEVEL3: 44,
  GERIATRICCAREASSIST: 45,
  ICONNECTYOU: 46,
  ICYAPI: 47,
  INDIVIDUALCOUNSELING: 48,
  LEGALASSISTNETWORKATTORNEY_30MINUTES_25_PERCENT_DISCOUNT: 49,
  LEGALASSISTNETWORKATTORNEY_60MINUTES_30_PERCENT_DISCOUNT: 50,
  LEGALASSISTTELEPHONICADVICEATTORNEY: 51,
  LIFECOACHING: 52,
  LIFECYCLEKITSMINI: 53,
  LIFECYCLEKITSPREMIUM: 54,
  LIFECYCLEKITSSUPERPREMIUM: 55,
  MEDIATION: 56,
  MYFAMILYCARENETWORK: 57,
  NANNYFIND: 58,
  NETWORKACCESSADMINISTRATION: 59,
  NETWORKACCESSMANAGEMENTLEVEL1: 60,
  NETWORKACCESSMANAGEMENTLEVEL2: 61,
  NETWORKACCESSMANAGEMENTADMINISTRATION: 62,
  NETWORKANALYSISREPORTS: 63,
  NICOTINEREPLACEMENTTHERAPY: 64,
  NOM035TRAUMATICEVENTSQUESTIONNAIRE: 65,
  NOM035SUPPORTOPTION1: 66,
  NOM035SUPPORTOPTION2: 67,
  NOM035SUPPORTOPTION3: 68,
  NURSINGMOTHERASSISTLEVEL1: 69,
  NURSINGMOTHERASSISTLEVEL2: 70,
  NURSINGMOTHERASSISTLEVEL3: 71,
  ORIENTATION: 72,
  PARTICIPANTWEBSITE: 73,
  PRESENCE: 74,
  PRESENCEPLUS: 75,
  RAPIDRESPONSECRITICALINCIDENTRRCI: 76,
  RAPIDRESPONSEHOTLINE: 77,
  REHABILITATION: 78,
  REMEDY: 79,
  RESELLERHYBRIDMODEL: 80,
  REVIVE: 81,
  SELECTASPECIALISTFORMERLYKNOWNASCOMPASS: 82,
  SOCIALASSISTANCEONSITE: 83,
  SOCIALASSISTANCETELEPHONIC: 84,
  STRESSASSESSMENTTOOLDELIVEREDBYBRIGHTLINK: 85,
  STRESSCHECKCHINA: 86,
  STRESSCHECKJAPAN: 87,
  SUBSIDYASSISTCONSULTING: 88,
  SUBSIDYASSISTGATEKEEPER: 89,
  SUBSIDYASSISTSUBSIDYMANAGEMENT: 90,
  SUBSTANCEABUSEPROFESSIONALSREFERRALSAP: 91,
  TOBACCOCESSATIONCOACHING: 92,
  TRAINING: 93,
  UCMSAPI: 94,
  UNIFIEDCASEMANAGEMENTSYSTEMUCMS: 95,
  WEBENHANCEMENTSDEVELOPMENTS: 96,
  ADMINFEE: 97,
  TDMANALYTICS: 98,
  TDMCONSULTING: 99,
  TDMDIGITALCOURSES: 100,
  TDMLEADERVIEW: 101,
  TDMLIBRARY: 102,
  TDMMICROVIDEOS: 103,
  RETURNTOWORK_CANCERCARECOMPASS: 870,
  AMBASSADOR_PROGRAM: 422
};

//List of Countries applicable for Worklife Product
export const COUNTRIES_WORKLIFE = {
  STRING_VALUE_ENUM: {
    CANADA: "Canada",
    UNITEDSTATES: "United States",
    //UNITEDSTATESMINOROUTLYINGISLANDS: "United States Minor Outlying Islands",
  },
  ID_VALUE_ENUM: {
    CANADA: 40,
    UNITEDSTATES: 240,
    //UNITEDSTATESMINOROUTLYINGISLANDS: 241,
  },
};

//List of Countries applicable for Total Source Product
export const COUNTRIES_TOTALSOURCE = {
  STRING_VALUE_ENUM: {
    UNITEDSTATES: "United States",
    //UNITEDSTATESMINOROUTLYINGISLANDS: "United States Minor Outlying Islands",
  },
  ID_VALUE_ENUM: {
    UNITEDSTATES: 240,
    //UNITEDSTATESMINOROUTLYINGISLANDS: 241,
  },
};

//List of Countries applicable for Worklife Product
export const COUNTRIES_EVOLUTION = {
  STRING_VALUE_ENUM: {
    CANADA: "Canada",
    UNITEDKINGDOM: "United Kingdom",
  },
  ID_VALUE_ENUM: {
    CANADA: 40,
    UNITEDKINGDOM: 239,
  },
};

//Products for which quote is calculated in CPQ
//BOH like products
export const CalculatedProductsForAmHours = {
  EAP: AllProductsEnum.EAP,
  STUDENTASSIST: AllProductsEnum.STUDENTASSIST,
  TOTALSOURCE: AllProductsEnum.TOTALSOURCE,
  EVOLUTION: AllProductsEnum.EVOLUTION,
  BANKOFHOURSADDITIONALCOUNSELINGSESSIONS:
    AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS,
  WELLNESSCOACHING: AllProductsEnum.WELLNESSCOACHING,
  GLOBALWELLBEINGQUESTIONNAIRE: AllProductsEnum.GLOBALWELLBEINGQUESTIONNAIRE,
  NEWPARENTRETURNTOWORK: AllProductsEnum.NEWPARENTRETURNTOWORK,
  PATHWAYS: AllProductsEnum.PATHWAYS,
  WORKLIFE: AllProductsEnum.WORKLIFE,
  ORIENTATION: AllProductsEnum.ORIENTATION,
  RAPIDRESPONSECRITICALINCIDENTRRCI:
    AllProductsEnum.RAPIDRESPONSECRITICALINCIDENTRRCI,
  TRAINING: AllProductsEnum.TRAINING,
};
export const CalculatedProducts = {
  ...CalculatedProductsForAmHours,
  ENHANCEDLEGALSERVICES: AllProductsEnum.ENHANCEDLEGALSERVICES,
  ENHANCEDFINANCIALSERVICES: AllProductsEnum.ENHANCEDFINANCIALSERVICES,
};
export const CalculatedProductsForHours = {
  EVOLUTION: AllProductsEnum.EVOLUTION,
  WORKLIFE: AllProductsEnum.WORKLIFE,
  ENHANCEDFINANCIALSERVICES: AllProductsEnum.ENHANCEDFINANCIALSERVICES,
  ENHANCEDLEGALSERVICES: AllProductsEnum.ENHANCEDLEGALSERVICES,
  HELPLINE: AllProductsEnum.HELPLINE,
  EAP: AllProductsEnum.EAP,
  TOTALSOURCE: AllProductsEnum.TOTALSOURCE,
  STUDENTASSIST: AllProductsEnum.STUDENTASSIST,
  WELLNESSCOACHING: AllProductsEnum.WELLNESSCOACHING,
};
export const PricingStructuresEnum = {
  FFS: 1,
  FLATFEEANNUAL: 2,
  FLATFEEMONTHLY: 3,
  PEPM: 4,
  PEPY: 5,
  FLATFEEONETIME: 6,
  FFSPERHOUR: 7,
  FFSPERCASE: 8,
  FFSDONOTUSE: 9,
  PERKIT: 10,
  FFSPERCALL: 11,
  PERPARTICIPANT: 12,
  FFSPERHALFDAY: 13,
  FFSPERFULLDAY: 14,
  FLATFEEQUARTERLY: 15,
  FFSPERSESSION: 16,
  FFSPERPACKAGE: 17,
  PROBONO: 18,
  PEREMPLOYEEPERPOLICY: 19,
  FFSPER30MINUTECALL: 20,
  FFSPER40MINUTECALL: 21,
  PERCENTOFFEESPROCESSEDMONTHLY: 22,
  FLATFEE_BANKOFCASES: 43,
};

export const BankOfHoursComponentsEnum = {
  CONSULTING: 128,
  RAPIDRESPONSECRITICALINCIDENT: 129,
  TRAINING: 130,
  ORIENTATION: 131,
  COUNSELING: 132,
  ITDEVELOPMENT: 133,
};

//Component wise pricing structure mapping
export const BOHComponentPricingStructureMap = [
  {
    name: "FFSPERHOUR",
    id: PricingStructuresEnum.FFSPERHOUR,
    fkey: BankOfHoursComponentsEnum.COUNSELING,
  },
  {
    name: "FFSPERSESSION",
    id: PricingStructuresEnum.FFSPERSESSION,
    fkey: BankOfHoursComponentsEnum.COUNSELING,
  },
  {
    name: "PEPM",
    id: PricingStructuresEnum.PEPM,
    fkey: BankOfHoursComponentsEnum.RAPIDRESPONSECRITICALINCIDENT,
  },
  {
    name: "PEPY",
    id: PricingStructuresEnum.PEPY,
    fkey: BankOfHoursComponentsEnum.RAPIDRESPONSECRITICALINCIDENT,
  },
  {
    name: "FLATFEEANNUAL",
    id: PricingStructuresEnum.FLATFEEANNUAL,
    fkey: BankOfHoursComponentsEnum.RAPIDRESPONSECRITICALINCIDENT,
  },
  {
    name: "FLATFEEMONTHLY",
    id: PricingStructuresEnum.FLATFEEMONTHLY,
    fkey: BankOfHoursComponentsEnum.RAPIDRESPONSECRITICALINCIDENT,
  },
  {
    name: "FLATFEEQAURTERLY",
    id: PricingStructuresEnum.FLATFEEQUARTERLY,
    fkey: BankOfHoursComponentsEnum.RAPIDRESPONSECRITICALINCIDENT,
  },
  {
    name: "FFSPERHOUR",
    id: PricingStructuresEnum.FFSPERHOUR,
    fkey: BankOfHoursComponentsEnum.RAPIDRESPONSECRITICALINCIDENT,
  },
  {
    name: "PEPM",
    id: PricingStructuresEnum.PEPM,
    fkey: BankOfHoursComponentsEnum.TRAINING,
  },
  {
    name: "PEPY",
    id: PricingStructuresEnum.PEPY,
    fkey: BankOfHoursComponentsEnum.TRAINING,
  },
  {
    name: "FLATFEEANNUAL",
    id: PricingStructuresEnum.FLATFEEANNUAL,
    fkey: BankOfHoursComponentsEnum.TRAINING,
  },
  {
    name: "FLATFEEMONTHLY",
    id: PricingStructuresEnum.FLATFEEMONTHLY,
    fkey: BankOfHoursComponentsEnum.TRAINING,
  },
  {
    name: "FLATFEEQAURTERLY",
    id: PricingStructuresEnum.FLATFEEQUARTERLY,
    fkey: BankOfHoursComponentsEnum.TRAINING,
  },
  {
    name: "FFSPERHOUR",
    id: PricingStructuresEnum.FFSPERHOUR,
    fkey: BankOfHoursComponentsEnum.TRAINING,
  },
  {
    name: "PEPM",
    id: PricingStructuresEnum.PEPM,
    fkey: BankOfHoursComponentsEnum.ORIENTATION,
  },
  {
    name: "PEPY",
    id: PricingStructuresEnum.PEPY,
    fkey: BankOfHoursComponentsEnum.ORIENTATION,
  },
  {
    name: "FLATFEEANNUAL",
    id: PricingStructuresEnum.FLATFEEANNUAL,
    fkey: BankOfHoursComponentsEnum.ORIENTATION,
  },
  {
    name: "FLATFEEMONTHLY",
    id: PricingStructuresEnum.FLATFEEMONTHLY,
    fkey: BankOfHoursComponentsEnum.ORIENTATION,
  },
  {
    name: "FLATFEEQAURTERLY",
    id: PricingStructuresEnum.FLATFEEQUARTERLY,
    fkey: BankOfHoursComponentsEnum.ORIENTATION,
  },
  {
    name: "FFSPERHOUR",
    id: PricingStructuresEnum.FFSPERHOUR,
    fkey: BankOfHoursComponentsEnum.ORIENTATION,
  },
];

export const BankOfHoursComponentMappingMasterArray = [
  { name: "CONSULTING", id: 128 },
  { name: "RAPIDRESPONSECRITICALINCIDENT", id: 129 },
  { name: "TRAINING", id: 130 },
  { name: "ORIENTATION", id: 131 },
  { name: "COUNSELING", id: 132 },
  { name: "ITDEVELOPMENT", id: 133 },
  { name: "PROMOTIONALEVENTS", id: 1189 },
];

export const OpportunityType = [
  {
    cpqOpportunityType: "NEW",
    crmOpportunityType: "New Business",
  },
  {
    cpqOpportunityType: "NEW",
    crmOpportunityType: "UpSell",
  },
  {
    cpqOpportunityType: "NEW",
    crmOpportunityType: "Cross Sell",
  },
  {
    cpqOpportunityType: "NEW",
    crmOpportunityType: "New Relationship",
  },
  {
    cpqOpportunityType: "RENEWAL",
    crmOpportunityType: "New Business/Renewal",
  },
  {
    cpqOpportunityType: "RENEWAL",
    crmOpportunityType: "Renewal (Existing Business)",
  },
  {
    cpqOpportunityType: "NEW",
    crmOpportunityType: "Transfer/New Business",
  },
  {
    cpqOpportunityType: "NEW",
    crmOpportunityType: "Transfer",
  },
];

export const QuoteStatus = {
  SAVEASDRAFT: 1,
  QUOTEPENDINGPRICINGTEAM: 2,
  QUOTEPENDINGSAMLEADERSHIP: 3,
  QUOTEAPPROVED: 4,
  CONTRACTED: 5,
  CONTRACTEDRESERVATIONSMARGINCONCERNS: 6,
  CONTRACTEDRESERVATIONSCONTRACTEDTERMUTILIZATION: 7,
  CONTRACTEDRESERVATIONSMINBILLINGNOTGUARANTEED: 8,
  QUOTECLOSED: 9,
  QUOTEPENDINGINITIALREQUESTOR: 10,
  CLOSEDWITHOUTAPPROVAL: 11,
  QUOTEPENDINGPRICINGMANAGER: 12,
  QUOTEPENDINGPRICINGMANAGERANDSAMLEADERSHIP: 13,
  QUOTEPENDINGPRICINGVPANDSAMLEADERSHIP: 14,
  QUOTEPENDINGPRICINGVP: 15,
};

export const UserRole = {
  SAMTEAM: 1,
  PRICINGTEAM: 2,
  SAMLEADERSHIPTEAM: 3,
  PRICINGMANAGER: 4,
  PRICINGVP: 5,
  SAMLEADERSHIPTEAMLEVEL3: 6,
};

export const ProductsEnum = {
  EAP: 1,
  BANKOFHOURSSESSIONS: 8,
};

export const LocalStorageKeys = {
  ISDISCOUNTCHANGED: "isDiscountChanged",
  USEREMAIL: "UserEmail",
  OPPORTUNITYID: "OpportunityId",
  CRMDATAINITIAL: "CRMInitial",
  LOGGEDUSER: "LoggedUser",
  BUNDLEQUOTEIDS: "bundleQuoteIds",
  ENCRYPTEDOPPID: "EncryptedOppId",
  MANAGEDATATAB: "ManageDataTab",
  CURRENTPAGE: "CurrentPage",
  REDIRECTRENDER: "RedirectRender",
  ENCRYPTEDURL: "EncryptedUrl",
  QS_USEREMAIL: "QueryStringUserEmail",
  ISEMAILSENT: "IsEmailSent",
  CURRENTFETCHEDCRMDATA: "CurrentCRMData",
  CURRENTWORKINGOPPORTUNITY: "CurrentOpportunity",
  COMPAREOPPORTUNITIESLIST: "CompareOpportunitiesList",
};

export const PageName = {
  HOMEPAGE: "Home",
  QUOTEPAGE: "Create Request",
  MANAGEDATAPAGE: "Manage Data",
  MANAGEUSERPAGE: "Manage Users",
  MANAGESYNCPAGE: "Manage Sync",
  MANAGEBUNDLESPAGE: "Manage Bundles",
  ERRORPAGE: "PageNotFound",
};

export const SeatCountToolTip = <div>for eLearning only</div>;

export const DiscountToolTip = (
  <div>
    <ul>
      <li>
        Discount/Increase is percentage based. All numbers inserted are meant to
        be percentages
      </li>
      <li>Anything above 0 will increase pricing.</li>
      <li>Anything below 0 will decrease pricing.</li>
      <li>
        Limited to "-100". Example of -100: non-profit organizations where WPO
        will be providing services for free.
      </li>
    </ul>
  </div>
);

export const BundleDiscountToolTip = (
  <div>
    <ul>
      <li>
        Bundle Discount/Increase is percentage based. All numbers inserted are
        meant to be percentages
      </li>
      <li>
        Bundle Discount/Increase is applied at bundle level, affecting
        individual quote calculation upon final bundle approval
      </li>
      <li>Anything above 0 will increase pricing.</li>
      <li>Anything below 0 will decrease pricing.</li>
      <li>
        Limited to "-100". Example of -100: non-profit organizations where WPO
        will be providing services for free.
      </li>
    </ul>
  </div>
);

export const NoOfRamsToolTip = (
  <div>
    How many RAMs should be considered for this opportunity so pricing team can
    calculate AM hours.
    <p>
      <b>
        <u>Typical number of RAM per opportunity</u>
      </b>{" "}
      segment:
      <ul>
        <li>
          <b>Medium </b> less than $100K - 0 to 1 RAM{" "}
        </li>
        <li>
          <b>Silver </b>above $100K and below $400K - 1 to 2 RAM
        </li>
        <li>
          <b>Gold </b>above $400K and below $1M - 2 to 4 RAM{" "}
        </li>
        <li>
          <b>Platinum </b>above $1M - bespoke{" "}
        </li>
      </ul>
      <p>
        <b>
          <u>NOTE:</u>
        </b>{" "}
        RAMs are only assigned where the regional/country headcount is more than
        1000 employees
      </p>
    </p>
  </div>
);

export const samPricingToolTip = (
  <div>
    Your opinion matters. Include what assumptions you're using to support your
    suggestion.
    <b>
      {" "}
      Any price reduction requests for existing clients will need to be reviewed
      by JB
    </b>
  </div>
);

export const renewalToolTip = (
  <div>
    <p> Always check Dynamics before responding. </p>
    <p>
      IF already being served through another Partner, please indicate partner
      name, current rate, headcount, session model and utilization.Pricing team
      will need go through client's data to support calculations.{" "}
    </p>
    <p>IF not served through another partner, please type N/A</p>
  </div>
);

export const isProductNotLikeBOH = (productId) => {
  return (
    productId !== AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS &&
    productId !== AllProductsEnum.PATHWAYS &&
    productId !== AllProductsEnum.GLOBALWELLBEINGQUESTIONNAIRE &&
    productId !== AllProductsEnum.NEWPARENTRETURNTOWORK &&
    productId !== AllProductsEnum.ORIENTATION &&
    productId !== AllProductsEnum.RAPIDRESPONSECRITICALINCIDENTRRCI &&
    productId !== AllProductsEnum.TRAINING
  );
};

export const isProductLikeBOH = (productId) => {
  return (
    productId === AllProductsEnum.BANKOFHOURSADDITIONALCOUNSELINGSESSIONS ||
    productId === AllProductsEnum.PATHWAYS ||
    productId === AllProductsEnum.GLOBALWELLBEINGQUESTIONNAIRE ||
    productId === AllProductsEnum.NEWPARENTRETURNTOWORK ||
    productId === AllProductsEnum.ORIENTATION ||
    productId === AllProductsEnum.RAPIDRESPONSECRITICALINCIDENTRRCI ||
    productId === AllProductsEnum.TRAINING
  );
};
